"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DecreaseFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DecreaseFilled = function DecreaseFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 15a4 4 0 004-4V5a4 4 0 00-4-4H5a4 4 0 00-4 4v6a4 4 0 004 4h6zm.047-3.252L7 11.75a.75.75 0 01-.743-.648L6.25 11l.007-.102a.75.75 0 01.641-.641L7 10.25h2.188L4.47 5.53l-.073-.084a.75.75 0 01-.007-.882l.08-.094.084-.073a.75.75 0 01.882-.007l.094.08 4.72 4.72V7l.007-.102a.75.75 0 011.486 0L11.75 7v4l-.002.051-.01.085-.027.103-.035.086-.055.095-.09.11-.08.069-.03.022-.052.032-.07.035-.06.023-.068.02-.124.018L7 11.75l4.047-.002z",
    fill: "currentColor"
  }));
};

exports.DecreaseFilled = DecreaseFilled;
var _default = DecreaseFilled;
exports.default = _default;